import { Device } from 'DeviceUtils';
import { StyleSheet } from 'react-native';
import { TOP_BAR_TOTAL_HEIGHT } from '../../../../runtime/Navigation/Menu/Menu.styles';
import Theme, { fontStyles } from 'Theme';

const defaultStyles = StyleSheet.create({
    container: {
        flex: 1,
        alignItems: 'center',
        paddingHorizontal: 18,
        justifyContent: 'flex-end',
        paddingBottom: '2.5%'
    },
    title: {
        ...fontStyles.title,
        color: 'white',
        textAlign: 'center',
        width: Device.isTabletOrWeb ? '45%' : '65%'
    },
    hrStyle: {
        width: Device.isTablet ? '40%' : '90%',
        marginVertical: 20,
        alignSelf: 'center'
    },
    subtitle: {
        ...fontStyles.subtitle,
        color: 'white',
        width: Device.isTabletOrWeb ? '50%' : '90%',
        textAlign: 'center',
        letterSpacing: 0.68
    },
    subtitleFull: {
        ...fontStyles.subtitle,
        color: 'white',
        width: Device.isTabletOrWeb ? '50%' : '90%',
        textAlign: 'center',
        letterSpacing: 0.68,
        paddingBottom: 24
    },
    subtitleInfo: {
        ...fontStyles.subtitle,
        width: Device.isTabletOrWeb ? '50%' : '90%',
        marginBottom: 24,
        textAlign: 'center'
    },
    subtitleInfoTasting: {
        ...fontStyles.subtitle,
        width: Device.isTabletOrWeb ? '50%' : '90%',
        marginTop: 24,
        textAlign: 'center'
    },
    buttonContainer: {
        flexDirection: 'column'
    },
    button: {
        width: 234,
        marginVertical: Theme.BU / 2,
        alignSelf: 'center'
    },
    buttonContinue: {
        textAlign: 'center'
    },
    logoBox: {
        alignItems: 'center',
        paddingTop: 24
    },
    logo: {
        alignSelf: 'center',
        justifyContent: 'center',
        width: 189.91,
        height: 50.64,
        marginBottom: 40
    },
    imageBackground: {
        flex: 1,
        justifyContent: 'center'
    },
    iconCloseContainer: {
        marginTop: Device.isAndroid ? 17 : 40,
        paddingHorizontal: 0,
        position: 'absolute',
        top: 0,
        right: 25
    },
    scrollContainer: {
        flexGrow: 1,
        justifyContent: 'center'
    },
    safeAreaContainer: {
        flex: 1,
        justifyContent: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.95)',
        marginTop: Device.isTabletOrWeb ? TOP_BAR_TOTAL_HEIGHT : 0
    }
});

export default defaultStyles;
